export const lead = {
    namespaced: true,
    state: {
        queue: null,
        leadInfo: {
            title: null,
            type: null
        },
        selected: [],
        selectUsers: {
            type: [],
            teams: [],
            supervisors: [],
            managers: []
        }
    },
    getters: {
        getQueue(state) {
            return state.queue
        },
        getSelected(state) {
            return state.selected
        },
        getTypes(state){
            return state.selectUsers.type
        },
        getTeams(state){
            return state.selectUsers.teams
        },
        getSupervisors(state){
            return state.selectUsers.supervisors
        },
        getManagers(state){
            return state.selectUsers.managers
        },
        getLeadInfo(state) {
            return state.leadInfo
        }
    },
    mutations: {
        SET_QUEUE(state, payload) {
            state.queue = []
            state.queue = payload
        },
        SET_SELECTED(state, payload) {
            if (!payload) return
            const index = state.selected.findIndex(item => item.id === payload.id)
            if (index >= 0) {
                state.selected.splice(index, 1)

            } else {
                state.selected.push(payload)
            }
        },
        SET_SELECTUSER(state, payload){
            state.selectUsers[payload.name] = payload.data
        },
        CLEAR_SELECTED(state) {
            state.selected = []
        },
        CLEAR_FILTEROPTIONS(state){
            state.selectUsers = {
                type: [],
                teams: [],
                supervisors: [],
                managers: []
            }
        },
        SET_LEAD_INFO(state, payload) {
            state.leadInfo = payload
        },
        CLEAR_LEAD_INFO(state) {
            state.leadInfo = {
                title: null,
                type: null
            }
        }
    },
    actions: {
        /**
         * Seta os dados da fila de leads
         * 
         * @param {*} payload 
         */
        setQueue({ commit }, payload) {
            commit('SET_QUEUE', payload)
        },
        /**
         * Recebe um usuário cadastrado para a fila de leads e o seleciona
         * 
         * @param {*} payload 
         */
        setSelected({ commit }, payload) {
            commit('SET_SELECTED', payload)
        },
        /**
         * Limpa a lista de usuários selecionados
         */
        clearSelected({ commit }) {
            commit('CLEAR_SELECTED')
        },
        /**
         * Seleciona todos os usuários cadastrados na fila de leads
         */
        selectAllUsers({ commit, getters }) {
            if (!getters.getQueue) return
            const total = getters.getQueue.lusers.length

            if (getters.getSelected.length < total) {
                commit('CLEAR_SELECTED')
                for (const lead of getters.getQueue.lusers) {
                    commit('SET_SELECTED', lead)
                }

            } else {
                commit('CLEAR_SELECTED')
            }
            
        },
        /**
         * Recebe os dados relacionados a selecao de usuarios.
         * 
         * @param {Object} payload 
         */
        setSelectUser({ commit }, payload) {
            commit('SET_SELECTUSER', payload)
        },

        clearFilterOptions({ commit }){
            commit('CLEAR_FILTEROPTIONS')
        },

        setLeadInfo({ commit }, payload) {
            commit('SET_LEAD_INFO', payload)
        },
        /**
         * Limpa a lista de usuários selecionados
         */
         clearLeadInfo({ commit }) {
            commit('CLEAR_LEAD_INFO')
        },
    }
}